'use client';

import { createContext, useContext } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { useShallow } from 'zustand/react/shallow';
import type { CartStoreState, CartStoreApi } from './cartStore';

export const CartStoreContext = createContext<CartStoreApi | null>(null);

export function useCartStoreApi(): CartStoreApi {
  const store = useContext(CartStoreContext);
  if (!store) {
    throw new Error('useCartStore must be used within a CartProvider');
  }
  return store;
}

export function useCartStore<T>(
  selector: (state: CartStoreState) => T,
  equalityFn?: (a: T, b: T) => boolean,
): T {
  const store = useCartStoreApi();
  return useStoreWithEqualityFn(store, selector, equalityFn);
}

export { useShallow };
